function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import TwoThirdsTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component";
import classnames from "classnames";
import Colors from "styles/colors";
import TabsComponent from "/components/core/tabs/tabs-component";
import FullParagraphComponent from "segments/desktop/paragraph/layouts/full-paragraph/full-paragraph-component";
import TabComponent from "/components/core/tabs/tab/tab-component";
import TagItemsGridComponent from "segments/desktop/grid/layouts/tag-items-grid/tag-items-grid-component";
import FlexibleCardGridComponent from "segments/desktop/grid/layouts/flexible-cards-grid/flexible-cards-grid-component";
import DefaultProps from "./default-props";
import { StyledPersonasTabsComponent } from "./personas-tabs-component.scss";
const PersonasTabsComponent = (props)=>{
    const DEFAULT_PADDING_TOP = "24px";
    const { tabs, tabsColor, tabsBackgroundColor, alignToLogo, swapTagsWithTextAndAssets, theme } = props;
    const componentsRenderer = (fullParagraph, tagItems, textAndAssetTwoThirds, flexibleCards)=>{
        if (swapTagsWithTextAndAssets) {
            return /*#__PURE__*/ _jsxs("div", {
                children: [
                    /*#__PURE__*/ _jsx(FullParagraphComponent, _object_spread({}, fullParagraph)),
                    /*#__PURE__*/ _jsx(TagItemsGridComponent, _object_spread({}, tagItems)),
                    /*#__PURE__*/ _jsx(TwoThirdsTextAndAssetComponent, _object_spread({}, textAndAssetTwoThirds)),
                    /*#__PURE__*/ _jsx(FlexibleCardGridComponent, _object_spread({}, flexibleCards))
                ]
            });
        }
        return /*#__PURE__*/ _jsxs("div", {
            children: [
                /*#__PURE__*/ _jsx(TwoThirdsTextAndAssetComponent, _object_spread({}, textAndAssetTwoThirds)),
                /*#__PURE__*/ _jsx(FullParagraphComponent, _object_spread({}, fullParagraph)),
                /*#__PURE__*/ _jsx(TagItemsGridComponent, _object_spread({}, tagItems)),
                /*#__PURE__*/ _jsx(FlexibleCardGridComponent, _object_spread({}, flexibleCards))
            ]
        });
    };
    const tabsRenderer = ()=>{
        return tabs === null || tabs === void 0 ? void 0 : tabs.map((tab, index)=>{
            const { tabLabel, textAndAssetTwoThirds = {}, fullParagraph = {}, tagItems = {}, flexibleCards = {}, tabId } = tab;
            const { textAndAssetPaddingTop } = textAndAssetTwoThirds;
            const { fullParagraphPaddingTop } = fullParagraph;
            const { tagItemsPaddingTop } = tagItems;
            const { flexibleCardsPaddingTop, imagePaddingBottom } = flexibleCards;
            return /*#__PURE__*/ _jsx(TabComponent, {
                className: "tab-component-container",
                tabId: tabId,
                label: tabLabel,
                color: tabsColor,
                theme: theme,
                unsetLabelColor: true,
                children: /*#__PURE__*/ _jsx("div", {
                    className: "components-container",
                    style: {
                        "--text-and-asset-padding-top": textAndAssetPaddingTop || DEFAULT_PADDING_TOP,
                        "--full-paragraph-padding-top": fullParagraphPaddingTop || DEFAULT_PADDING_TOP,
                        "--tag-items-padding-top": tagItemsPaddingTop || DEFAULT_PADDING_TOP,
                        "--flexible-cards-padding-top": flexibleCardsPaddingTop || DEFAULT_PADDING_TOP,
                        "--flexible-cards-padding-bottom": imagePaddingBottom
                    },
                    children: componentsRenderer(fullParagraph, tagItems, textAndAssetTwoThirds, flexibleCards)
                })
            }, index);
        });
    };
    const backgroundColor = Colors[tabsBackgroundColor];
    const underlineColor = Colors[tabsColor];
    const { autoTransition, scrollOnTabClick, scrollSpeed, distanceFromTop, activeTabId } = props;
    return /*#__PURE__*/ _jsx(StyledPersonasTabsComponent, {
        className: classnames("personas-tabs-component-container", {
            "align-to-logo": alignToLogo
        }),
        children: /*#__PURE__*/ _jsx("div", {
            className: "personas-tabs-component",
            style: {
                "--tab-background-color": backgroundColor,
                "--tab-underline-color": underlineColor
            },
            children: /*#__PURE__*/ _jsx(TabsComponent, {
                autoTransition: autoTransition,
                scrollOnTabClick: scrollOnTabClick,
                scrollSpeed: scrollSpeed,
                distanceFromTop: distanceFromTop,
                activeTabId: activeTabId,
                role: "tabpanel",
                children: tabsRenderer()
            })
        })
    });
};
PersonasTabsComponent.defaultProps = DefaultProps;
export default PersonasTabsComponent;
